export function getSelectedFilterName(filters, isSelected) {
    var _a;
    return ((_a = filters.find(isSelected)) === null || _a === void 0 ? void 0 : _a.name) || "";
}
//# sourceMappingURL=getSelectedFilterName.js.map